import { ServiceCompanies } from '@/service/companies/serviceCompanies'
import { ServiceCompanyInvite } from '@/service/companies/serviceComapnyInvite'
import Swal from 'sweetalert2'

const apigrupo = new ServiceCompanies()
const apiInvite = new ServiceCompanyInvite()
export default {
  namespaced: true,
  state: {
    groups: [],
    listCompanyMembers: {
      company: {},
      companyMembers: [],
    },
    activeGroup: null,
    loading: false, // Estado de loading
    ListCompanyInvites: [],
    listInvitesReceived: [],
  },
  getters: {
    getGroups: state => state.groups,
    getActiveGroup: state => state.activeGroup,
    getCompanyMembers: state => state.listCompanyMembers,
    listCompanyInvites: state => state.ListCompanyInvites,
    listInvitesReceived: state => state.listInvitesReceived,
  },
  mutations: {
    SET_LOADING(state, status) {
      state.loading = status
    },
    SET_GROUPS(state, groups) {
      state.groups = groups
    },
    SET_ACTIVE_GROUP(state, groupId) {
      state.activeGroup = groupId
      localStorage.setItem('activeGroup', groupId)
    },
    ADD_GROUP(state, newGroup) {
      state.groups.push(newGroup)
    },
    SET_COMPANY_MEMBERS(state, members) {
      state.listCompanyMembers = members
    },
    SET_LIST_COMPANY_INVITES(state, invites) {
      state.ListCompanyInvites = invites
    },
    SET_LIST_INVITES_RECEIVED(state, invites) {
      state.listInvitesReceived = invites
    },

    ADD_INVITE(state, invite) {
      if (state.invitesReceived) {
        state.invitesReceived.invites = [invite, ...state.invitesReceived.invites]
      } else {
        state.invitesReceived = {
          message: 'Received invites',
          invites: [invite],
        }
      }
    },
  },
  actions: {
    async fetchGroups({ commit }) {
      commit('SET_LOADING', true) // Inicia o loading
      try {
        const response = await apigrupo.getListCompanies()
        commit('SET_GROUPS', response.empresas)
        const activeGroup = localStorage.getItem('activeGroup')
        commit('SET_ACTIVE_GROUP', activeGroup ? parseInt(activeGroup) : null)
      } catch (error) {
        console.error('Erro ao buscar grupos:', error)
      } finally {
        commit('SET_LOADING', false) // Finaliza o loading
      }
    },
    async createGroup({ commit }, groupData) {
      commit('SET_LOADING', true)
      try {
        const response = await apigrupo.createGroup(groupData)
        commit('ADD_GROUP', response)
        return response // Return the successful response
      // eslint-disable-next-line no-useless-catch
      } catch (error) {
        throw error // Re-throw the error instead of returning it
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async setPAPermission(_, { id, bool }) {
      await apigrupo.setPAPermission(id, bool)
    },

    async setActiveGroup({ commit }, groupId) {
      commit('SET_LOADING', true)
      try {
        await apigrupo.setActive(groupId)
        commit('SET_ACTIVE_GROUP', groupId)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Erro ao definir grupo ativo:', error)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async listCompanyMembers({ commit }, { id, params }) {
      commit('SET_LOADING', true)
      try {
        const response = await apigrupo.ListCompanyMembers(id, params)
        commit('SET_COMPANY_MEMBERS', response)
        return response
      } catch (error) {
        console.error('Erro ao buscar membros da empresa:', error)
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async assignAdmin({ commit }, data) {
      commit('SET_LOADING', true)
      try {
        return await apigrupo.assignAdmin(data)
      } catch (error) {
        console.error('Erro ao atribuir administrador:', error)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async setGroupPercent({ commit }, { id, val }) {
      commit('SET_LOADING', true)
      try {
        const response = await apigrupo.setGroupPercent(id, val)
        return response
      } catch (error) {
        console.error('Erro ao atualizar percentual:', error)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    // invite services

    async getListCompanyInvites({ commit }, id) {
      commit('SET_LOADING', true)
      try {
        const result = await apiInvite.getListCompanyInvites(id)
        commit('SET_LIST_COMPANY_INVITES', result)
      } catch (error) {
        console.error('Erro ao buscar convites:', error)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async sendInvite({ commit }, data) {
      commit('SET_LOADING', true)
      try {
        return await apiInvite.sendInvite(data)
      } catch (error) {
        console.error('Erro ao enviar convite:', error)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async acceptInvite({ commit }, data) {
      commit('SET_LOADING', true)
      try {
        return await apiInvite.acceptInvite(data)
      } catch (error) {
        console.error('Erro ao aceitar convite:', error)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async rejectInvite({ commit }, data) {
      commit('SET_LOADING', true)
      try {
        return await apiInvite.rejectInvite(data)
      } catch (error) {
        console.error('Erro ao rejeitar convite:', error)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async getInvitesReceived({ commit }) {
      commit('SET_LOADING', true)
      try {
        const received = await apiInvite.getCompanyInvites()
        commit('SET_LIST_INVITES_RECEIVED', received.invites)
      } catch (error) {
        console.error('Erro ao buscar convites:', error)
      } finally {
        commit('SET_LOADING', false)
      }
    },

  },
}
